import logobar from 'components/logobar'

export default async (oldContainer, newContainer, lastClickEl, done) => {
  await logobar.open()
  await window.scrollTo(0, 0)
  await done()
  await logobar.close()
}
